
import { defineComponent } from "vue";
import AppViewToggle from "@/common/components/AppViewToggle.vue";
import TrendingTokens from "@/modules/market/components/TrendingTokens.vue";
import CreatorsList from "@/modules/market/components/CreatorsList.vue";
import {
  assetInterface,
  collectionsInterface,
  userInterface,
} from "@/services";
import CategoryList from "@/modules/market/components/CategoryList.vue";
import { useAsyncLoading } from "@/common/composables/useAsyncLoading";

export default defineComponent({
  components: {
    CategoryList,
    AppViewToggle,
    TrendingTokens,
    CreatorsList,
  },
  setup() {
    const [allAssetsLoading, allAssets] = useAsyncLoading(
      assetInterface.getAll({ limit: 4 }).then((res) => res.assets)
    );

    const [featuredCreatorsLoading, featuredCreators] = useAsyncLoading(
      userInterface.getAll({
        featuredCreators: true,
      })
    );

    const [allCollectionsLoading, allCollections] = useAsyncLoading(
      collectionsInterface.getAll({ limit: 4 })
    );

    return {
      allAssetsLoading,
      allAssets,
      featuredCreatorsLoading,
      featuredCreators,
      allCollectionsLoading,
      allCollections,
    };
  },
});
